import React from 'react';
import PropTypes from 'prop-types';

class SelectorBase extends React.Component {
  input = null;
  isControlled = null;

  constructor(props, context) {
    super(props, context);
    this.state = {};
    this.isControlled = props.checked != null;
    if (!this.isControlled) {
      this.state.checked = props.checked !== undefined ? props.checked : false;
    }
  }

  handleInputChange = event => {
    const { onChange } = this.props;
    const checked = event.target.checked;

    if (!this.isControlled) {
      this.setState({ checked });
    }

    if (onChange) {
      onChange(event, checked);
    }
  };

  render() {
    const {
      checked: checkedProp,
      className,
      disabled,
      id,
      inputProps,
      name,
      type,
      value,
      tabIndex,
    } = this.props;
    const { checked: stateChecked } = this.state;
    const checked = this.isControlled ? checkedProp : stateChecked;

    return (
      <input
        id={id}
        type={type}
        name={name}
        checked={checked}
        onChange={this.handleInputChange}
        disabled={disabled}
        value={value}
        tabIndex={tabIndex !== undefined ? tabIndex : (inputProps && inputProps.tabIndex !== undefined ? inputProps.tabIndex : 0)}
        className={`${type === 'checkbox' ? 'eKCanB' : className}`}
        {...inputProps}
      />
    );
  }
}

SelectorBase.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),

  className: PropTypes.string,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * If `true`, the component appears indeterminate.
   */
  indeterminate: PropTypes.bool,
  /**
   * Properties applied to the `input` element.
   */
  inputProps: PropTypes.oneOfType([PropTypes.object]),
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: PropTypes.func,
  /*
   * @ignore
   */
  name: PropTypes.string,

  onChange: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),

  tabIndex: PropTypes.number,

  type: PropTypes.string,
  /**
   * The value of the component.
   */
  value: PropTypes.string,
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const SelectorBase = ({prop = val, type = 'checkbox', checked = false, className = '', disabled = false, id = 'SBase-1', indeterminate = false, inputProps = { }) =>
SelectorBase.defaultProps = {
  type: 'checkbox',
  checked: false,
  className: '',
  disabled: false,
  id: 'SBase-1',
  indeterminate: false,
  inputProps: {},
  inputRef: () => null,
  name: '',
  onChange: null,
  value: '',
};

export default SelectorBase;
